/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'dns-policy';
const componentName = 'dns-policy-action';
const prefix = `${moduleName}.${componentName}`;

export const allowDropQueryLabel = `${prefix}.allowDropQueryLabel`;
export const rateLimitLabel = `${prefix}.rateLimitLabel`;
export const queryResponseLabel = `${prefix}.queryResponseLabel`;
export const allowDnsQueryLabel = `${prefix}.allowDnsQueryLabel`;
export const resetTcpConnectionLabel = `${prefix}.resetTcpConnectionLabel`;
export const dnsResponseCodeLabel = `${prefix}.dnsResponseCodeLabel`;
export const truncationLabel = `${prefix}.truncationLabel`;
export const authoritativeLabel = `${prefix}.authoritativeLabel`;
export const responseCodeLabel = `${prefix}.responseCodeLabel`;
export const groupNameLabel = `${prefix}.groupNameLabel`;

export const ENGLISH = {
    [allowDropQueryLabel]: 'Allow/Drop Query',
    [rateLimitLabel]: 'Rate Limit',
    [queryResponseLabel]: 'Query Response',
    [allowDnsQueryLabel]: 'Allow DNS Query',
    [resetTcpConnectionLabel]: 'Reset TCP Connection',
    [dnsResponseCodeLabel]: 'DNS Response Code',
    [truncationLabel]: 'Truncation',
    [authoritativeLabel]: 'Authoritative',
    [responseCodeLabel]: 'Response Code',
    [groupNameLabel]: 'Group Name',
};
